import { render, staticRenderFns } from "./print-bons.html?vue&type=template&id=95607448&scoped=true&external"
import script from "./print-bons.js?vue&type=script&lang=js&external"
export * from "./print-bons.js?vue&type=script&lang=js&external"
import style0 from "./print-bons.scss?vue&type=style&index=0&id=95607448&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95607448",
  null
  
)

export default component.exports